var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffer1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2e9e9e;stroke:#fff;stroke-width:12px;}.b{fill:#fff;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-286 -3057)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(286 3057)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 84.5,
    cy: 84.5,
    r: 84.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 84.5,
    cy: 84.5,
    r: 78.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M201.114,38.371A44.7,44.7,0,0,1,173,28c-8.8,8.889-20.532,10.371-27.377,10.371A37.284,37.284,0,0,1,140,38V57.089c0,40,33,50.911,33,50.911s33-10.911,33-50.911V38a27.163,27.163,0,0,1-4.889.371ZM168.879,81.333l-14.026-15,4.126-5,9.9,7.083L189.5,53l3.712,3.333Z",
    transform: "translate(196.997 3074)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer1);
export default __webpack_public_path__ + "static/media/offer_1.924fadf7da19d71d760ee998afc412f2.svg";
export { ForwardRef as ReactComponent };